import React from 'react';
import PropTypes, {
  bool,
  string,
  shape,
  number,
} from 'prop-types';
import { useTranslation } from 'react-i18next';

import Toogle from 'components/toogle';
import Checkbox from 'components/checkbox';
import Help from 'components/help';

import {
  StyledCheckAllButton,
  StyledCheckBoxPanel,
  StyledCheckBoxPanelBody,
  StyledCheckBoxPanelBodyItems,
  StyledCheckBoxPanelBodyText,
  StyledCheckBoxPanelFooter,
  StyledCheckBoxPanelTitle,
  StyledCheckBoxItem,
} from './styles';

const Panel = ({
  className,
  items,
  onChangeItems,
  onChangeShowInCatalog,
  showInCatalog,
  title,
  titleSelectAll,
  withFooter,
}) => {
  const { t } = useTranslation();

  const handleSelectAll = () => {
    const newList = items.map((item) => {
      const newItem = { ...item };
      newItem.selected = true;
      return newItem;
    });
    onChangeItems(newList);
  };

  const handleOnSelect = (checked, index) => {
    const newList = JSON.parse(JSON.stringify(items));
    newList[index].selected = checked;
    onChangeItems(newList);
  };

  const renderFooter = () => {
    if (withFooter) {
      return (
        <StyledCheckBoxPanelFooter>
          <Toogle label={t('pages.globalFiltersPage.showFilters')} onChange={onChangeShowInCatalog} checked={showInCatalog} />
          <Help text={t('pages.globalFiltersPage.showFiltersToolTip')} />
        </StyledCheckBoxPanelFooter>
      );
    }
    return <></>;
  };

  return (
    <StyledCheckBoxPanel className={className}>
      <StyledCheckBoxPanelTitle>
        {title}
      </StyledCheckBoxPanelTitle>
      <StyledCheckBoxPanelBody>
        <StyledCheckBoxPanelBodyText>{t('pages.globalFiltersPage.selectMinOne')}</StyledCheckBoxPanelBodyText>
        <StyledCheckBoxPanelBodyItems>
          {items.map((item, index) => (
            <StyledCheckBoxItem key={`${item.name}${item.id}`}>
              <Checkbox
                label={item.name}
                checked={item.selected}
                onChange={(checked) => handleOnSelect(checked, index)}
              />
            </StyledCheckBoxItem>
          ))}
        </StyledCheckBoxPanelBodyItems>
        <StyledCheckAllButton onClick={handleSelectAll}>{titleSelectAll}</StyledCheckAllButton>
      </StyledCheckBoxPanelBody>
      {renderFooter()}
    </StyledCheckBoxPanel>
  );
};

Panel.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(shape({
    id: number,
    name: string,
    selected: bool,
  })).isRequired,
  onChangeItems: PropTypes.func.isRequired,
  onChangeShowInCatalog: PropTypes.func,
  showInCatalog: PropTypes.bool,
  title: PropTypes.string.isRequired,
  titleSelectAll: PropTypes.string.isRequired,
  withFooter: PropTypes.bool,
};

Panel.defaultProps = {
  className: null,
  withFooter: true,
  showInCatalog: false,
  onChangeShowInCatalog: () => {},
};

export default Panel;
